import React from 'react';
import styled from 'styled-components';
import { CollectionEPDModel } from 'services/EpdClient';
import { IconButton } from '../buttons';
import { useTranslation } from 'react-i18next';

interface Props {
  epd: CollectionEPDModel;
  isEditMode: boolean;
  onRemove(id: string): void;
}

const EpdCollectionItem: React.FC<Props> = ({ epd, isEditMode, onRemove }) => {
  const { t } = useTranslation();
  const statusText = t(`epdWizard.epdState.status.${epd.statusDisplayName}`);

  return (
    <EpdCollectionItemBox style={isEditMode ? undefined : { backgroundColor: '#EEF1F4' }}>
      <div>
        <EpdTitle>{`${epd.fullNumber} - ${statusText}`}</EpdTitle>
        <EpdName>{epd.name}</EpdName>
      </div>
      {isEditMode && <IconButton icon="pi pi-trash" text onClick={(e) => onRemove(epd.id!)} />}
    </EpdCollectionItemBox>
  );
};

const EpdCollectionItemBox = styled.div`
  align-self: center;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  background: rgba(180, 208, 182, 0.3);
  border-radius: 2px;
  margin: 4px 29px;
  padding: 0.75rem 1rem;
`;

const EpdTitle = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  /* identical to box height */

  letter-spacing: -0.02em;

  /* Primary/Black 50 */

  color: rgba(21, 21, 21, 0.5);
`;

const EpdName = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  /* identical to box height */

  letter-spacing: -0.02em;

  /* Primary/Black */

  color: #151515;
`;

export default EpdCollectionItem;
